'use strict';

function LoanApplicationReview() {
  var _this5 = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];

  this._$classes = {
    form: '.js--loan-application-review-form',
    doneBtn: '.js--done',
    editBtn: '.js--edit-cta',
    reviewConsentGroup: '.js--loan-application-review-consent-group',
    reviewConsent: '.js--loan-application-review-consent',
    textPaymentFrequency: '.js--loan-application--regular-payment',
    extensionRow: '.js--loan-application--ext', // Hide Extension Row if no value
    premiumDisclaimer: '.js--loan-application--payment-disclaimer' // One off disclaimer, thats not consistent with rest of the designs
  };

  // Dynamic Loan Protected Description sets
  this._loanProtectionContent = {
    default: {
      accepted: 'Payment includes principal, interest, and optional loan protection premium of ',
      declined: 'Payment includes principal and interest only. You did not opt in to loan protection.'
    },
    goeasy: {
      accepted: 'Payment includes principal, interest, and optional Loan Protection Plan premium of ',
      declined: 'Payment includes principal and interest only. It does not include the optional Loan Protection Plan premium.'
    },
    inEligible: 'Payment includes principal and interest.'
  };

  this._fieldsInteractedWith = [];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    // Guard to prevent users from accessing this page too early without required information
    // This page looks for submitted information
    if (this._loanApplications[0].hasSubmittedEmployment() === false || this._loanApplications[0].hasSubmittedLoanAmount() === false || this._loanApplications[0].hasSubmittedIncome() === false) {
      return;
    }

    this._$node = $(this.node);
    this._submissionFlag = false;

    // Check for level up, Existing loan
    this._isActiveLoan = !!(this._getLoanStatus() && this._getLoanStatus().status && this._getLoanStatus().status === 'active');

    // For Elements
    this._$form = this._$node.find(this._$classes.form);
    this._$reviewConsent = this._$node.find(this._$classes.reviewConsent);
    this._$reviewConsentGroup = this._$node.find(this._$classes.reviewConsentGroup);

    // computedVariable elements
    this._$textPaymentFrequency = this._$node.find(this._$classes.textPaymentFrequency);
    this._$premiumDisclaimer = this._$node.find(this._$classes.premiumDisclaimer);
    this._$doneButton = this._$node.find(this._$classes.doneBtn);
    this._$editButton = this._$node.find(this._$classes.editBtn);

    // PAY, PAYMENT, PAY TEXT - Used for seperate cases
    this._paymentFrequency = this._loanApplications[0].getPaymentFrequency();
    this._payFrequency = this._loanApplications[0].getPayFrequency();
    this._loanApplicationModel = this._loanApplications[0].getModelPath();
    this._employerExtension = this._loanApplications[0].getEmployerPhoneExt();
    this._hasHardConsent = this._loanApplications[0].hasHardConsent(); // cache original boolean

    // Payment option from offersObj
    this._loanApplicationAmount = this._loanApplications[0].getLoanApplicationAmount();
    this._loanApplicationLenderId = this._loanApplications[0].getApplicationLender();

    // Reset Model for when users click edit again.
    this._loanApplications[0].resetData();
    this._loanApplications[0].resetIncome();
    this.presenter.setModelProperty('money._loanApplicationEdit', false);

    if (this._employerExtension.length === 0) this._$node.find(this._$classes.extensionRow).hide();

    // Page Analytics
    this._attachDataAnalytics();
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);

    this._setTempPayOptionModel();
    this._setupComputedVariables();
    this._createTailoredConsent();

    // Events
    this._setupEventHandlers();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setTempPayOptionModel = function () {
    var _this = this;

    // use Submitted Loan Amount to populate screen
    // shouldn't be an else because at this stage, users will have loanOfferAmount
    this._activeOffer.getPaymentOption(this._loanApplicationAmount, function (payOption) {
      // No Model create one , else update the model else create model,
      if (!_this.presenter.getModelProperty('money._loanApplicationPayOption')) {
        _this.presenter.createModel('money._loanApplicationPayOption', {
          data: payOption
        });
      } else {
        _this.presenter.updateModel('money._loanApplicationPayOption', payOption);
      }
      // Need PAYMENT frequency to determine biweekly or monthly payment amount!, depends on paymentOptions array
      _this._populatePaymentValues();
      _this._pushLoanChoiceAnalytics(_this._loanApplicationAmount, payOption); // Dependent on payOption

      // Remove Loader after it's done
      _this._removeProgressLoader();
    });
  };

  this._getLoanApplicationDataFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.key));
      });
    }
  };

  this._setupEventHandlers = function () {
    var _this2 = this;

    this._$form.on('submit', this._onValidateForm.bind(this));

    // Edit btn, sets a model property, the edit pages can refer to this
    // property value to show/hide an alternate `save` cta
    this._$editButton.on('click', function (e) {
      e.preventDefault();
      _this2._resetInteractedFields();
      _this2.presenter.setModelProperty('money._loanApplicationEdit', true);
      _this2._history.goToUrl(e.currentTarget.href);
    });

    this._$reviewConsent.on('change', function () {
      _this2._$reviewConsentGroup.mogo().hideErrorLabel();
      _this2._$reviewConsent.mogo().hideError();
    });
  };

  this._onValidateForm = function (e) {
    e.preventDefault();
    this._$doneButton.mogo().setDisabledLoadState();
    var data = this._$form.serializeFormToObj();
    var payLoad = {};

    if (data.consent === false) {
      this._$doneButton.mogo().removeDisabledLoadState();

      this._$reviewConsentGroup.mogo().showErrorLabel(true, 'Hold up! Please consent to continue.');

      this._$reviewConsent.mogo().showError();

      this._pushFormErrorAnalytics('hard credit check consent');
      return;
    }
    // Must have Consent
    payLoad.hard_credit_check_consent = true;

    this._loanApplications[0].updateLoanApplicationStatus(payLoad, {
      success: this._onUpdateSuccess.bind(this),
      failure: this._onUpdateFailure.bind(this)
    }, this._$form[0]);
  };

  this._onUpdateSuccess = function (data, response) {
    this._pushFormSubmitAnalytics();
    this._setSubmissionFlag(true);

    this._$doneButton.mogo().removeDisabledLoadState();
    $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
  };

  this._onUpdateFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      this._$doneButton.mogo().removeDisabledLoadState();

      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this._setupComputedVariables = function () {
    var _this3 = this;

    // Display effective balance if there's an active loan
    // because user will be applying for a level up offer.
    if (this._isActiveLoan) {
      // Effective Balance: principal.amount_remaining - (next_payment.amount + next_payment.lp)
      this.presenter.addComputedVariable(
      // _liquidLoanPath is from MoneyController
      'loanEffectiveBalance', [this._loanApplicationModel + '.amount', this._liquidLoanPath + '.effective_balance'], function (selectedAmount, effectiveBalance) {
        if (selectedAmount && effectiveBalance) {
          return Formatters.formatMoney(selectedAmount - effectiveBalance);
        }
      });

      this.presenter.addComputedVariable('loanAmountRemaining', [this._liquidLoanPath + '.effective_balance'], function (val) {
        return Formatters.formatMoney(val.toFixed(2));
      });
    }

    this.presenter.addComputedVariable('loan_amount', [this._loanApplicationModel + '.amount'], function (val) {
      return Formatters.formatMoney(_this3._loanApplications[0].getLoanApplicationAmount().toFixed(2));
    });

    this.presenter.addComputedVariable('payment_date', [this._loanApplicationModel + '.employment.first_pay_date'], function (val) {
      var firstPaymentDate = _this3._loanApplications[0].getFirstPaymentDate();
      var date = _this3._loanApplications[0].getSubmittedPaymentDate();
      var dayDifference = parseInt(moment(firstPaymentDate).format('DD')) - parseInt(moment(date).format('DD')); // Fix UI bug where user selects 28 or 29 and a projected estimated date is on Feb 28th.
      // Project Feb. 28th UI bug
      if (_this3._paymentFrequency == 'monthly' && Math.abs(dayDifference) > 0 && moment(firstPaymentDate).format('MM-DD') === '02-28') {
        return moment(firstPaymentDate).add(1, 'days').format('ddd, MMM D');
      }
      return moment(firstPaymentDate).format('ddd, MMM D');
    });

    this.presenter.addComputedVariable('is_protected', [this._loanApplicationModel], function (val) {
      return _this3._loanApplications[0].isProtected() || '';
    });

    this.presenter.addComputedVariable('funding_method', [this._loanApplicationModel], function (val) {
      return 'Direct deposit';
    });

    this.presenter.addComputedVariable('payment_method', [this._loanApplicationModel], function (val) {
      return 'Pre-authorized debit';
    });

    // Employment
    this.presenter.addComputedVariable('employer_name', [this._loanApplicationModel + '.employment.name'], function (val) {
      return _this3._loanApplications[0].getEmployerName();
    });

    this.presenter.addComputedVariable('employer_phone_number', [this._loanApplicationModel + '.employment.phone_number'], function (val) {
      return Formatters.formatPhone(_this3._loanApplications[0].getEmployerPhoneNumber());
    });

    this.presenter.addComputedVariable('ext', [this._loanApplicationModel + '.employment.extension'], function (val) {
      return _this3._loanApplications[0].getEmployerPhoneExt();
    });

    this.presenter.addComputedVariable('your_occupation', [this._loanApplicationModel + '.employment.job_title'], function (val) {
      return _this3._loanApplications[0].getJobTitle();
    });

    // Income
    this.presenter.addComputedVariable('pay_frequency', [this._loanApplicationModel + '.employment.pay_frequency'], function (val) {
      return _this3._loanApplications[0].getPayFrequencyText();
    });

    // Consent
    this.presenter.addComputedVariable('consent_time', [this._loanApplicationModel + '.hard_credit_check_consented_at'], function (val) {
      var consentTime = _this3._loanApplications[0].getHardConsentTime();
      if (consentTime) {
        return moment(consentTime).format('MMMM DD');
      }
      return false;
    });
  };

  // PopulateToolTipMoneyValues: Formats the money values in the tooltip attached to regular_payments
  this._populatePaymentValues = function () {
    var _this4 = this;

    // Needs loanPaymentOption model.
    this.presenter.addComputedVariable('regular_payment', ['money._loanApplicationPayOption.amount'], function (val) {
      var isProtected = _this4._loanApplications[0].isProtected();
      var paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
      var premium = _this4.presenter.getModelProperty('money._loanApplicationPayOption.loan_protection_amount.' + _this4._paymentFrequency);
      var paymentAmount = '';
      // factor in Premiums!
      if (isProtected) {
        // Amount with premium
        paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
        premium = _this4.presenter.getModelProperty('money._loanApplicationPayOption.loan_protection_amount.' + _this4._paymentFrequency);
        paymentAmount = paymentFrequency + premium;
      } else {
        paymentFrequency = _this4.presenter.getModelProperty('money._loanApplicationPayOption.' + _this4._paymentFrequency);
        paymentAmount = paymentFrequency;
      }
      return Formatters.formatMoney(paymentAmount);
    });

    // determines if tool tip is shown
    this._isProtectedToolTip();

    // Populate the payment amount values
    if (this._paymentFrequency === 'monthly') {
      this._paymentFrequencyText = 'monthly';
    } else if (this._paymentFrequency === 'biweekly') {
      this._paymentFrequencyText = 'bi-weekly';
    }

    var frequency = '<b>' + this._paymentFrequencyText + '</b>';
    var label = 'Regular ' + frequency + ' payment';
    this._$textPaymentFrequency.html(label); // Populate the label
  };

  this._isProtectedToolTip = function () {
    var isUserEligible = this._loanApplications[0].isProtectionEligible();

    if (isUserEligible === false) {
      // None Eligible
      this._$premiumDisclaimer.html(this._loanProtectionContent.inEligible);
    } else {
      // Dynamic Disclaimer messages are shown to user depending on the LP status
      this._showCustomDisclaimer(this._loanApplicationLenderId);
    }
  };

  this._showCustomDisclaimer = function (lenderId) {
    var loanProtectionPremium = _this5.presenter.getModelProperty('money._loanApplicationPayOption.loan_protection_amount.' + _this5._paymentFrequency);
    var isProtected = _this5._loanApplications[0].isProtected();
    var accepted = '';
    var declined = '';

    switch (lenderId) {
      case 1:
        accepted = _this5._loanProtectionContent.default.accepted + '<span class=\'value\'>' + Formatters.formatMoney(loanProtectionPremium) + '</span>.';
        declined = _this5._loanProtectionContent.default.declined;
        break;
      case 2:
        accepted = _this5._loanProtectionContent.goeasy.accepted + '<span class=\'value\'>' + Formatters.formatMoney(loanProtectionPremium) + '</span>.';
        declined = _this5._loanProtectionContent.goeasy.declined;
        break;
      default:
        accepted = _this5._loanProtectionContent.default.accepted + '<span class=\'value\'>' + Formatters.formatMoney(loanProtectionPremium) + '</span>.';
        declined = _this5._loanProtectionContent.default.declined;
    }

    if (isProtected === false) {
      _this5._$premiumDisclaimer.html(declined);
    } else {
      // Eligible and opt in, use format Money for cents
      _this5._$premiumDisclaimer.html(accepted);
    }
  };

  // CreateTailoredConsent: Users get tailored consent content depending on their province.
  this._createTailoredConsent = function () {
    var _this6 = this;

    var partnerLenderConsentMsg = '';
    var province = this.presenter.models.account.province;

    var content = void 0;

    if (this._loanApplicationLenderId === 2) {
      partnerLenderConsentMsg = ' and sharing this credit report with a Partner Lender for this loan application';
    }

    switch (province) {
      case 'MB':
        content = 'I consent to Mogo using my personal information to obtain a credit report from a credit reporting agency' + partnerLenderConsentMsg + '. This consent will be valid so long as required to process this loan application.';
        break;
      case 'NL':
        content = 'I consent to Mogo using my personal information to obtain a credit report from a credit reporting agency' + partnerLenderConsentMsg + '. We currently use Equifax Canada Co., located at Box 190 Jean Talon Station, Montreal, Quebec H1S 2 Z2.';
        break;
      default:
        content = 'I consent to Mogo using my personal information to obtain a credit report from a credit reporting agency' + partnerLenderConsentMsg + '.';
    }

    // Name and ID should be different else checkbox will not toggle on label click
    if (this._$reviewConsent.length) {
      this._$reviewConsent.mogo().create('Checkbox', {
        placeholder: content
      });
    }

    mogo.ready(function () {
      // Hard Credit check
      if (_this6._loanApplications[0].hasHardConsent()) {
        _this6._disableReviewConsent();
      }

      _this6._onFieldInteraction($('.js--loan-application-review-consent'));
    });
  };

  this._disableReviewConsent = function () {
    var hasHardConsent = this._loanApplications[0].hasHardConsent(); // It's true at this point

    this._$reviewConsentGroup.mogo().setDisabled(hasHardConsent);
    this._$reviewConsent.mogo().setChecked(hasHardConsent);
    this._$reviewConsent.mogo().setDisabled(hasHardConsent);
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('loan_amount');
    this.presenter.removeComputedVariable('payment_date');
    this.presenter.removeComputedVariable('funding_method');
    this.presenter.removeComputedVariable('payment_method');
    this.presenter.removeComputedVariable('employer_name');
    this.presenter.removeComputedVariable('employer_phone_number');
    this.presenter.removeComputedVariable('your_occupation');
    this.presenter.removeComputedVariable('pay_frequency');
    this.presenter.removeComputedVariable('regular_payment');
    this.presenter.removeComputedVariable('ext');

    if (this._submissionFlag === false) {
      this._pushAbandonmentData();
    }
    this._super();
  };

  // Analytics
  this._setSubmissionFlag = function (boolean) {
    if (boolean !== null) this._submissionFlag = boolean;
  };

  this._findInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        this._fieldsInteractedWith.push($(fields[i].parentElement).attr('name'));
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }
  };

  this._pushAbandonmentData = function () {
    this._findInteractedFields();

    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  this._onFieldInteraction = function (domElement) {
    var elemName = domElement.attr('name');

    if (!elemName) return console.warn('Cannot find name in domElement, please pass through correct domElement');

    var elem = $('[name=\'' + elemName + '\']', this.node);
    var fieldComponent = $(elem).mogo();

    // From UI Schema Validation
    if (fieldComponent instanceof Select) {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
    } else if (fieldComponent instanceof BooleanGroup) {
      for (var j = 0; j < fieldComponent.groupElements.length; j++) {
        $(fieldComponent.groupElements[j]).on('focus', setInteractionField.bind(this, elem));
        $(fieldComponent.groupElements[j]).on('blur', setInteractionField.bind(this, elem));
      }
    } else {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('change', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
      $(elem).on('click', setInteractionField.bind(this, elem));
    }

    function setInteractionField(elem, event) {
      $(elem)[0].dataset.interacted = true;
    }
  };

  this._resetInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }

    this._fieldsInteractedWith = [];
  };

  this._pushFormErrorAnalytics = function (formId) {
    var formErrorId = null;
    if (formId) formErrorId = formId;

    this.analytics.forcePushEvent('form-errors', {
      FormErrors: [formErrorId]
    });
  };

  this._pushFormSubmitAnalytics = function () {
    // Send on first successful submission only.
    // However, this cannot be done because hard consent
    // is true right after successful submission
    // analytics have made a note for this. will revisit in later sprints.
    if (this._hasHardConsent === false) {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Loan Application Review-null-Form']
      });
    }
  };

  this._attachDataAnalytics = function () {
    if (this._loanApplications[0].hasHardConsent()) {
      this._$doneButton.attr('data-analytics-id', 'Money-Navigation-Looks Good-Navigation-Component');
    } else {
      this._$doneButton.attr('data-analytics-id', 'Money-Loan Application Review-Form attempt-null-SubmitClick');
    }
  };

  this._pushLoanChoiceAnalytics = function (loanAmount, payOption) {
    //  At this review point, Loan Protection and Loan Eligible should not be Null
    var isLoanProtection = this._loanApplications[0].isProtected();
    var isLoanEligible = this._loanApplications[0].isProtectionEligible();
    var loanChoice = 'Unavailable';

    // Retrieves the users loan protection choice
    // Returns whether the user is eligible for LP.
    // Determines by checking loan_policy_number &&
    // if loan_protection_amount key exists
    if (isLoanEligible !== true) {
      loanChoice = 'Unavailable';
    } else if (isLoanProtection !== true) {
      loanChoice = 'No';
    } else if (payOption.protection_policy_number && // no key in the object
    $.isEmptyObject(payOption.loan_protection_amount) !== true) {
      loanChoice = payOption.protection_policy_number; // STL or ETL
    }

    this.analytics.forcePushEvent('digital-loan-application-choices', {
      DLLAmount: [loanAmount],
      DLLLP: [loanChoice],
      DLLBalance: [this.presenter.getModelProperty(this._liquidLoanPath + '.effective_balance')]
    });
  };
}